"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFakeStaticOffer = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
const _1 = require(".");
faker_1.default.seed(718);
const generateFakeStaticOffer = (rules = 2) => {
    const mockDemandSubAccount = (0, _1.generateFakeDemandSubAccount)();
    const mockOffer = {
        createdAt: faker_1.default.date.recent(),
        createdByUuid: faker_1.default.datatype.uuid(),
        demandSubAccount: mockDemandSubAccount,
        enableRewardValue: faker_1.default.datatype.boolean(),
        id: faker_1.default.datatype.number({ min: 1 }),
        isAutoUpdating: faker_1.default.datatype.boolean(),
        monetizable: faker_1.default.datatype.boolean(),
        offerId: faker_1.default.datatype.number({ min: 1 }),
        offerRules: Array.from({ length: rules }, _1.generateFakeOfferRule),
        offerUuid: faker_1.default.datatype.uuid(),
    };
    return mockOffer;
};
exports.generateFakeStaticOffer = generateFakeStaticOffer;
